// import React, { useEffect, useState } from "react";
// import SideNavBar from "../SideNavBar";
// import ChatContextProvider from "../../contexts/ChatContext";
// import Contacts from "../ChatBox/Contacts/Contacts";
// import Main from "../ChatBox/Main/Main";
// import { Box , Button} from "@mui/material";
// import { QueryClientProvider, QueryClient } from "react-query";
// import VideoState from "../../contexts/VideoState";
// import CallModal from "../ChatBox/options/CallModal";
// import VideoChat from "../ChatBox/Calling/VideoChat";
// import { withRouter } from 'react-router-dom';
// import { useSelector } from "react-redux";

// const queryClient = new QueryClient();

// const ChatBoxPage = () => {
//   const { showChats, showContacts } = useSelector((state) => state.manageChat);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);

//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);
//   console.log('windowWidthjj:', windowWidth, showChats);

//   // const { InboxId = '', GroupInboxId = '' } = (history.location.state || {});

//   return (
//     <SideNavBar>
//          <ChatContextProvider>
//         <QueryClientProvider client={queryClient}>
//           <Box display='flex' flexDirection={windowWidth < 769 ? "column" : "row"} maxHeight='80vh' style={{ overflowY: "auto" }}>
//           <CallModal />
//           <VideoChat />
//           {windowWidth < 769 && showChats ? ( null ) : ( <Contacts />)}
//             <Main/>
//           </Box>
//         </QueryClientProvider>
//       </ChatContextProvider>
//     </SideNavBar>
//   );
// };

// export default ChatBoxPage;



// import React, { useEffect, useState } from "react";
// import SideNavBar from "../SideNavBar";
// import ChatContextProvider from "../../contexts/ChatContext";
// import Contacts from "../ChatBox/Contacts/Contacts";
// import Main from "../ChatBox/Main/Main";
// import { Box , Button} from "@mui/material";
// import { QueryClientProvider, QueryClient } from "react-query";
// import VideoState from "../../contexts/VideoState";
// import CallModal from "../ChatBox/options/CallModal";
// import VideoChat from "../ChatBox/Calling/VideoChat";
// import { withRouter } from 'react-router-dom';
// import { useSelector } from "react-redux";

// const queryClient = new QueryClient();

// const ChatBoxPage = () => {
//   const { showChats, showContacts } = useSelector((state) => state.manageChat);
  
//   return (
//     <SideNavBar>
//       <ChatContextProvider>
//         <QueryClientProvider client={queryClient}>
//           <Box 
//             sx={{
//               display: 'flex',
//               height: 'calc(100vh - 64px)', // Adjust based on your navbar height
//               width: '100%',
//               overflow: 'hidden',
//               bgcolor: '#f0f2f5'
//             }}
//           >
//             <CallModal />
//             <VideoChat />
            
//             {/* Left Contacts Sidebar - Fixed Width */}
//             <Box 
//               sx={{
//                 width: '400px',
//                 minWidth: '400px',
//                 height: '100%',
//                 bgcolor: 'white',
//                 borderRight: '1px solid #e0e0e0',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 overflow: 'hidden'
//               }}
//             >
//               <Contacts />
//             </Box>
            
//             {/* Right Main Chat Area - Takes remaining space */}
//             <Box 
//               sx={{
//                 flex: 1,
//                 height: '100%',
//                 bgcolor: '#f0f2f5',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 overflow: 'hidden'
//               }}
//             >
//               <Main />
//             </Box>
//           </Box>
//         </QueryClientProvider>
//       </ChatContextProvider>
//     </SideNavBar>
//   );
// };

// export default ChatBoxPage;



import React, { useEffect, useState } from "react";
import SideNavBar from "../SideNavBar";
import ChatContextProvider from "../../contexts/ChatContext";
import Contacts from "../ChatBox/Contacts/Contacts";
import Main from "../ChatBox/Main/Main";
import { Box } from "@mui/material";
import { QueryClientProvider, QueryClient } from "react-query";
import CallModal from "../ChatBox/options/CallModal";
import VideoChat from "../ChatBox/Calling/VideoChat";
import { useSelector } from "react-redux";

const queryClient = new QueryClient();

const ChatBoxPage = () => {
  const { showChats, showContacts } = useSelector((state) => state.manageChat);
  
  return (
    <SideNavBar>
      <ChatContextProvider>
        <QueryClientProvider client={queryClient}>
          <Box 
            sx={{
              display: 'flex',
              height: 'calc(100vh - 64px)',
              width: '100%',
              overflow: 'hidden',
              bgcolor: '#f0f2f5'
            }}
          >
            <CallModal />
            <VideoChat />
            
            <Box 
              sx={{
                width: '370px',
                minWidth: '370px',
                maxWidth: '370px',
                height: '100%',
                minHeight: '89vh',
                maxHeight: '89vh',
                bgcolor: 'white',
                borderRight: '1px solid #e0e0e0',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                position: 'relative'
              }}
            >
              <Contacts />
            </Box>

            <Box 
              sx={{
                flex: 1,
                height: '100%',
                minHeight: '89vh',
                maxHeight: '89vh',
                bgcolor: '#f0f2f5',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
              }}
            >
              <Main />
            </Box>
          </Box>
        </QueryClientProvider>
      </ChatContextProvider>
    </SideNavBar>
  );
};

export default ChatBoxPage;